import { useState } from "react";
import { ChevronDown, ChevronRight, Wrench, Loader2, Check, AlertCircle } from "lucide-react";
import { ToolCallView } from "@/types/chat";

interface ToolCallBlockProps {
  call: ToolCallView;
}

export const ToolCallBlock = ({ call }: ToolCallBlockProps) => {
  const [open, setOpen] = useState(false);
  const Icon = call.status === 'running' ? Loader2 : call.status === 'errored' ? AlertCircle : Check;
  return (
    <div className="mb-2 rounded-lg border border-border/40 bg-muted/20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 px-3 py-2 text-xs hover:bg-muted/30"
      >
        {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Wrench className="h-3 w-3" />
        <span className="font-medium">{call.toolName}</span>
        <Icon className={`ml-auto h-3 w-3 ${call.status === 'running' ? 'animate-spin text-primary' : call.status === 'errored' ? 'text-destructive' : 'text-muted-foreground'}`} />
      </button>
      {/* {open && (
        <div className="space-y-2 px-3 pb-2 text-xs">
          <div>
            <div className="text-muted-foreground">Arguments</div>
            <pre className="whitespace-pre-wrap break-all rounded bg-background/60 p-2 font-mono">
              {call.args || '(no arguments)'}
            </pre>
          </div>
          {call.result !== undefined && (
            <div>
              <div className="text-muted-foreground">Result</div>
              <pre className="whitespace-pre-wrap break-all rounded bg-background/60 p-2 font-mono">
                {call.result || '(no result)'}
              </pre>
            </div>
          )}
        </div>
      )} */}
    </div>
  );
};
